import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Info } from 'lucide-react';

interface CustomOutletInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const CustomOutletInput: React.FC<CustomOutletInputProps> = ({
  value,
  onChange,
  placeholder = 'Enter outlet name'
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="custom-outlet">Don't see your outlet? Enter it here:</Label>
      <Input
        id="custom-outlet"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full"
      />
      {value && (
        <Alert>
          <Info className="h-4 w-4" />
          <AlertDescription className="text-sm">
            Your submission will be reviewed and may be added to our list.
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
};
